import { clsx } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { AppIcon, appIcons } from '@/components/ui/app-icon/app-icon';
import Tooltip from '@mui/material/Tooltip';
import { ChevronRight } from 'lucide-react';
import { useGetImmoConfigQuery } from '@/redux/queries/common.ts';

interface HelpAreaBoxProps {
    isCollapsed: boolean;
}

function HelpAreaBox({ isCollapsed }: HelpAreaBoxProps) {
    const [t] = useTranslation();
    const { data } = useGetImmoConfigQuery();
    const helpUrl = data?.helpUrl?.trim();

    if (!helpUrl) {
        return null;
    }

    const handleClick = () => {
        window.open(helpUrl, '_blank', 'noopener,noreferrer');
    };

    const HelpAreaContent = (
        <div
            onClick={handleClick}
            className={clsx(
                'px-2 py-3 rounded-lg flex justify-between items-center gap-2 transition-colors cursor-pointer',
                'bg-primary2/10 text-primary2 hover:bg-primary2/20',
                isCollapsed && 'justify-center',
            )}>
            <div className={clsx('flex flex-col', isCollapsed && 'items-center')}>
                <div className={clsx('flex items-center gap-2', isCollapsed && 'm-auto', 'h-5')}>
                    <span className="text-primary2">
                        <AppIcon icon={appIcons.info} />
                    </span>
                    <span className={clsx('text-sm font-medium', isCollapsed && 'hidden')}>
                        {t('helpArea.title')}
                    </span>
                </div>
                {!isCollapsed && (
                    <div className="pl-6 mt-1">
                        <p className="text-xs text-primary2/70">{t('helpArea.description')}</p>
                    </div>
                )}
            </div>
            {!isCollapsed && <ChevronRight className="h-4 w-4 shrink-0 text-primary2" />}
        </div>
    );

    if (isCollapsed) {
        return (
            <Tooltip title={t('helpArea.title')} placement="right">
                {HelpAreaContent}
            </Tooltip>
        );
    }

    return HelpAreaContent;
}

export default HelpAreaBox;
